;
(function (ng) {
  'use strict';

  angular.module('defaultButton', []);
})(window.angular);